import React from "react";

const Filters = ({
  sectors,
  levelOfEducation,
  location,
  setSelectedChoices,
  selectedChoices,
}) => {
  const handleSelectChoice = (e, val) => {
    const isChecked = e.target.checked;
    const name = e.target.name;
    if (isChecked) {
      setSelectedChoices({
        ...selectedChoices,
        [val]: [...selectedChoices[val], name],
      });
    } else {
      let newItem = selectedChoices[val].filter((choice) => {
        return choice !== name;
      });
      setSelectedChoices({ ...selectedChoices, [val]: newItem });
    }
  };

  const buildChoices = (title, val, choices) => (
    <div>
      <h2 className="text-lg text-slate-800 mb-2">{title}</h2>
      <ul>
        {choices.map((choice, i) => {
          if (!choice || choice.toLowerCase().includes("other"))
            return <li className="hidden" key={i}></li>;
          return (
            <li className="flex mb-1 text-sm" key={i}>
              <label className="inline-flex items-center mt-3">
                <input
                  name={choice}
                  type="checkbox"
                  className="form-checkbox h-5 w-5 text-indigo-600"
                  onChange={(e) => handleSelectChoice(e, val)}
                />
                <span className="ml-2 text-gray-700">{choice}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );

  return (
    <div className="col-span-2 lg:col-span-1 sticky top-24 hidden md:block">
      <div className="">
        {buildChoices("Sectors", "Sector", sectors, handleSelectChoice)}
        <br />
        {buildChoices(
          "Level of Education",
          "Level_of_Education",
          levelOfEducation
        )}
        <br />
        {buildChoices("Location", "Location", location, handleSelectChoice)}
      </div>
    </div>
  );
};

export default Filters;
